<template>
  <div>
    <v-btn
      class="btn-center"
      color="primary"
      dark
      :loading="loading"
      :disabled="loading"
      @click="downloadResults"
    >
        Download results
    </v-btn>      
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import {
  LOAD_SLIDES_WITH_DIAGNOSIS,
  LIST,
} from "@/store/modules/annotation";
export default {
  props: {
    project: Object
  },
  data: () => {
    return {
    }
  },
  computed: {
    ...mapState({
      loading: state => state.annotation.loading
    }),
    ...mapGetters({
      list: LIST
    })
  },
  methods: {
    downloadResults() {
      const wsiDiagnosisDict = {}
      this.list.map( wsi => {
        wsiDiagnosisDict[wsi.id] = {}
        wsi.diagnosis.forEach(diagnosis => {
          wsiDiagnosisDict[wsi.id][diagnosis.annotation_class.class_name] = (wsiDiagnosisDict[wsi.id][diagnosis.annotation_class.class_name] || 0) + 1;
        });
      })
      const data = "data:" + JSON.stringify(wsiDiagnosisDict, null, 4);
      console.log(data);
      const blob = new Blob([data], {type: 'text/plain'})
      const e = document.createEvent('MouseEvents'),
      a = document.createElement('a');
      a.download = "KappaTestResult.json";
      a.href = window.URL.createObjectURL(blob);
      a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
      e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      a.dispatchEvent(e);
    }
  },
  async created() {
    this.$store.dispatch(LOAD_SLIDES_WITH_DIAGNOSIS);
  }
}
</script>
<style lang="scss" scoped>
.btn-center {
  left: 50%;
  transform: translateX(-50%);
}
</style>